import React, { useContext, useEffect } from 'react'
import HomeNavBar from '../Component/HomeComponent/HomeNavBar'
import ContactForm from '../Component/ContactForm'
import { Helmet } from 'react-helmet'
import { HrStorage } from '../Context/HrStore'

const ContactPage = () => {
    let { active, setactive } = useContext(HrStorage)
    useEffect(() => {
        setactive('contact')
        window.scrollTo(0, 0)
    }, [])
    return (
        <div className='min-h-screen bg-slate-50' >
            <Helmet>
                <title>Reach Us Today | Merida HR</title>
                <meta name="description" content=" Get in touch with our expert HR consultants today for personalized solutions tailored to your organization's needs. Let's drive success together!" />
                <link rel="canonical" href="https://www.meridahr.com/contact" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "ContactPage",
                        "name": "Contact Merida HR Consulting",
                        "description": "Reach out to our Jayanagar, Bangalore headquarters or regional offices for staffing, HR outsourcing, payroll, and compliance needs."
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "RecruitmentAgency",
                        "name": "Merida HR Consulting",
                        "image": "https://www.meridahr.com/MeridaConsultancyLogo.png",
                        "telephone": "+91-8904599282",
                        "email": "info@meridahr.com",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "1st Floor, 334/28, 14th Cross Rd, 2nd Block, Jayanagar",
                            "addressLocality": "Bengaluru",
                            "addressRegion": "Karnataka",
                            "postalCode": "560011",
                            "addressCountry": "IN"
                        }
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            {
                                "@type": "ListItem",
                                "position": 1,
                                "name": "Home",
                                "item": "https://www.meridahr.com/"
                            },
                            {
                                "@type": "ListItem",
                                "position": 2,
                                "name": "Contact",
                                "item": "https://www.meridahr.com/contact"
                            }
                        ]
                    })}
                </script>
            </Helmet>
            
            {/* Dark Blue Header Section */}
            <div className="relative bg-[#01014C] pt-32 pb-48 overflow-hidden">
                <div className="absolute inset-0 opacity-20" style={{ backgroundImage: `radial-gradient(#ffffff 2px, transparent 2px)`, backgroundSize: '30px 30px' }} />
                
                <div className="absolute w-full top-0 z-50">
                    <HomeNavBar type='white' />
                </div>

                <div className="container mx-auto px-6 relative z-10 text-center mt-10">
                    <p className="text-blue-400 font-bold tracking-[0.3em] text-[10px] uppercase mb-4">Contact Us</p>
                    <h1 className="text-4xl md:text-6xl font-bold text-white syne mb-6">Let's Connect</h1>
                    <p className="text-white/80 text-lg max-w-2xl mx-auto">
                        Ready to optimize your workforce? Get in touch with our expert HR consultants today for personalized solutions tailored to your organization's needs.
                    </p>
                </div>
            </div>

            {/* Form Section Overlapping the Header */}
            <div className="-mt-32 relative z-20 mb-20">
                <ContactForm />
            </div>

        </div>
    )
}

export default ContactPage